export class HostingSftp {

  public username: string;
  public password: string;
  public port: string;

}

